'use client'

/**
 * Booking Chatbot Wrapper
 *
 * Client component that reads booking context and renders the chatbot widget.
 */

import { useEffect } from 'react'
import { useBooking } from '@/contexts/BookingContext'
import { ChatbotWidget } from '@/components/chatbot'

export function BookingChatbot() {
  const {
    tenantId,
    tenantName,
    tenantBrandName,
    tenantLogo,
    propertyId,
    propertyName,
    isLoading,
    error,
  } = useBooking()

  // Debug logging
  useEffect(() => {
  }, [isLoading, error, tenantId, tenantName])

  // Don't render if context is not loaded or there's an error
  if (isLoading || error || !tenantId) {
    return null
  }

  return (
    <ChatbotWidget
      tenantId={tenantId}
      tenantName={tenantBrandName || tenantName || 'Hotel'}
      tenantLogo={tenantLogo}
      propertyId={propertyId}
      propertyName={propertyName}
    />
  )
}
